import { render, staticRenderFns } from "./SEOCollectionBlock.vue?vue&type=template&id=bc2db9cc&lang=pug&"
import script from "./SEOCollectionBlock.vue?vue&type=script&lang=js&"
export * from "./SEOCollectionBlock.vue?vue&type=script&lang=js&"
import style0 from "./SEOCollectionBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc2db9cc')) {
      api.createRecord('bc2db9cc', component.options)
    } else {
      api.reload('bc2db9cc', component.options)
    }
    module.hot.accept("./SEOCollectionBlock.vue?vue&type=template&id=bc2db9cc&lang=pug&", function () {
      api.rerender('bc2db9cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/SEOCollectionBlock.vue"
export default component.exports